import React from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@pixi/react';

import { gameStore } from '../../../../../store/gameStore';

import PayTableSymbolOdds from './payTableSymbolOdds';

const oddsInfoEnumWeb = [
  { id: 0, oddX: 20, oddContainerY: 25, oddsContainerX: 745, oddsContainerY: 214 },
  { id: 1, oddX: 20, oddContainerY: 25, oddsContainerX: 1068, oddsContainerY: 214 },
  { id: 2, oddX: 20, oddContainerY: 25, oddsContainerX: 412, oddsContainerY: 430 },
  { id: 3, oddX: 20, oddContainerY: 25, oddsContainerX: 732, oddsContainerY: 430 },
  { id: 4, oddX: 20, oddContainerY: 25, oddsContainerX: 1062, oddsContainerY: 430 },
  { id: 5, oddX: 20, oddContainerY: 25, oddsContainerX: 412, oddsContainerY: 549 },
  { id: 6, oddX: 20, oddContainerY: 25, oddsContainerX: 732, oddsContainerY: 549 },
  { id: 7, oddX: 20, oddContainerY: 25, oddsContainerX: 1062, oddsContainerY: 549 },
];

const PayTableSymbolsOdds = observer(() => {
  const { oddsInfo } = gameStore;

  return (
    <Container name='PayTableOddsContainer'>
      {oddsInfoEnumWeb.map((item, index) => {
        return (
          <Container
            key={item.id}
            x={item.oddsContainerX}
            y={item.oddsContainerY}
            name='PayTableSymbolsOddsContainer'
          >
            {oddsInfo[index]?.map((odd, oddIndex) => {
              return (
                <PayTableSymbolOdds
                  key={`${item.id}${odd}`}
                  odd={odd}
                  oddX={item.oddX || 0}
                  oddY={item.oddY || 0}
                  oddIndex={oddIndex}
                  oddContainerY={item.oddContainerY}
                />
              );
            })}
          </Container>
        );
      })}
    </Container>
  );
});

export default PayTableSymbolsOdds;
